import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from "@angular/router";
import { AuthService } from '../auth/auth.service';
import { first, Observable, of } from 'rxjs';

/**
 * AuthGuardService is used to check if the application can activate. The application
 * can only activate if the user is logged in. Otherwise, they are navigated to the login
 * screen
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  /**
   * Default constructor to initalize services 
   * 
   * @param _authService
   * @param _router 
   */
  constructor(
    private _authService: AuthService,
    private _router: Router,
  ) {}

  /**
   * Attempt to activate the application by checking authentication status
   * 
   * @returns status on if activation was successful
   */
   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    // If the token hasn't loaded, subscribe to the auth service to wait for it to load
    if (!this._authService.loadedToken) {

      this._authService.isAuthenticated$.pipe(first()).subscribe({
        next: (isAuthenticated) => {
          return of(isAuthenticated);
        }
      });
    }

    if (this._authService.authenticated) {
      // User is authenticated, allow activation
      return of(true);
    } else {
      // User is not authenticated, navigate to login
      this._router.navigate(['/login']);
      return of(false);
    }
  }
}